import { render, staticRenderFns } from "./FitnessplanChallengeIntermediate.vue?vue&type=template&id=73150476&scoped=true&"
import script from "./FitnessplanChallengeIntermediate.vue?vue&type=script&lang=js&"
export * from "./FitnessplanChallengeIntermediate.vue?vue&type=script&lang=js&"
import style0 from "./FitnessplanChallengeIntermediate.vue?vue&type=style&index=0&id=73150476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73150476",
  null
  
)

export default component.exports